import { E99Constants } from '../Constants';
import { adminUsersServices } from '../Services';

export const E99Actions = {
    searchE99Providers
};

function searchE99Providers(data: any) {
    return (dispatch: any) => {
        dispatch(dispatchFunction({
            type: E99Constants.SEARCH_E99_REQUEST,
            data: null
        }));
        adminUsersServices.searchE99Providers(data)
            .then(
                response => {
                    if (response.status) {
                        dispatch(dispatchFunction({
                            type: E99Constants.SEARCH_E99_SUCCESS,
                            data: response.data
                        }));
                    } else {
                        dispatch(dispatchFunction({
                            type: E99Constants.SEARCH_E99_FAILURE,
                            data: response
                        }));
                    }
                },
                error => {
                    dispatch(dispatchFunction({
                        type: E99Constants.SEARCH_E99_FAILURE,
                        data: error.message
                    }));
                }
            );
    };
}

function dispatchFunction(data: any) {
    // To do: check for refresh / unauthorized error
    return {
        type: data.type,
        data: data.data
    };
}